<template>
  <div :class="[isH5 ? 'h5Wrapper':'pcWrapper']">
    <a href="https://www.messenger.com/t/109806164762675">
      <img src="../../assets/facebook.png" alt="facebook">
    </a>
    <a href="https://t.me/CS2q247">
      <img src="../../assets/telegram.png" alt="telegram">
    </a>
  </div>
</template>

<script>
export default {
  name: "SysContact",
  props: {
    isH5: {
      type: Boolean
    }
  }
}
</script>

<style lang="less" scoped>
@plugin "../../utils/plugin";
.pcWrapper {
  display: flex;
  align-items: center;
  column-gap: px(23);

  img {
    height: px(59);
    width: px(59);
  }
}
.h5Wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 25px;
  img {
    width: 59px;
    height: 59px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SysContact.vue